import {
  LayoutDashboard,
  FolderOpen,
  Briefcase,
  Users,
  Settings,
  Wrench,
  Calendar,
  ClipboardCheck,
  FileText,
  BarChart3,
  Building2,
  FileBarChart,
  Bell
} from 'lucide-react'
import { SideLink } from './sidelinks'

export const operationsManagersLinks: SideLink[] = [
  {
    title: 'Dashboard',
    href: '/operations-manager/dashboard',
    icon: <LayoutDashboard size={18} />,
  },
  {
    title: 'Projects',
    href: '/operations-manager/projects',
    icon: <Briefcase size={18} />,
    sub: [
      {
        title: 'Overview',
        href: '/operations-manager/projects',
        icon: <FolderOpen size={18} />,
      }
    ],
  },
  {
    title: 'Team Management',
    href: '/operations-manager/team',
    icon: <Users size={18} />,
  },
  {
    title: 'Resource Management',
    href: '/operations-manager/resources',
    icon: <Settings size={18} />,
    sub: [
      {
        title: 'Staff',
        href: '/operations-manager/staff',
        icon: <Users size={18} />,
      },
      {
        title: 'Equipment',
        href: '/operations-manager/equipment',
        icon: <Wrench size={18} />,
      },
    ],
  },
  {
    title: 'Schedule',
    href: '/operations-manager/schedule',
    icon: <Calendar size={18} />,
  },
  {
    title: 'Quality Control',
    href: '/operations-manager/quality',
    icon: <ClipboardCheck size={18} />,
    sub: [
      {
        title: 'Inspections',
        href: '/operations-manager/quality/inspections',
        icon: <ClipboardCheck size={18} />,
      },
      {
        title: 'Reports',
        href: '/operations-manager/quality/reports',
        icon: <FileText size={18} />,
      },
    ],
  },
  {
    title: 'Work Orders',
    href: '/operations-manager/work-orders',
    icon: <FileText size={18} />,
  },
  {
    title: 'Analytics',
    href: '/operations-manager/analytics',
    icon: <BarChart3 size={18} />,
  },
  {
    title: 'Client Management',
    href: '/operations-manager/clients',
    icon: <Building2 size={18} />,
  },
  {
    title: 'Reports',
    href: '/operations-manager/reports',
    icon: <FileBarChart size={18} />,
  },
  {
    title: 'Notifications',
    href: '/operations-manager/notifications',
    icon: <Bell size={18} />,
  },
]